import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: 800,
    height: 700,
  },
}));
